const s = {
  name: "WatermelonPart",
  dimensions: { width: 40, height: 22 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 22" style="enable-background:new 0 0 40 22;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,14v-4h-2v4H21z"/>
		<path class="st0" d="M27.9,3.5l3.8,1.2l-0.6,1.9l-3.8-1.2L27.9,3.5z"/>
		<path class="st0" d="M14.5,7.9l-2.4,3.2l1.6,1.2l2.4-3.2L14.5,7.9z"/>
		<path class="st0" d="M26.2,12.3l-2.4-3.2l1.6-1.2l2.4,3.2L26.2,12.3z"/>
		<path class="st0" d="M8.9,6.7l3.8-1.2l-0.6-1.9L8.3,4.8L8.9,6.7z"/>
		<path class="st0" d="M18.9,0H0v2c0,11,9,20,20,20s20-9,20-20V0H25.1l-0.2,0.8C24.6,2,23.4,3,22,3s-2.6-1-2.9-2.2L18.9,0z M20,20
			C10.1,20,2,11.9,2,2h2c0,8.8,7.2,16,16,16s16-7.2,16-16h2C38,11.9,29.9,20,20,20z M34,2c0,7.7-6.3,14-14,14S6,9.7,6,2h11.4
			C18.2,3.8,20,5,22,5s3.8-1.2,4.6-3H34z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as WatermelonPart
};
